import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    snapshotFilterData: []
}
const SnapshotFilterSlice = createSlice({
    name: 'snapshotFilterFields',
    initialState,
    reducers: {
        handleFilterSliceData(state, action) {
            state.snapshotFilterData = action.payload
        }
    }
})

export const { handleFilterSliceData } = SnapshotFilterSlice.actions

export default SnapshotFilterSlice.reducer
